import 'whatwg-fetch';
import axios from 'axios';

import { checkIfUserIsLoggedIn } from '../modules/app';

const PREFIX = 'fetch-middleware/';

export const FETCH =   PREFIX + 'FETCH';
export const REQUEST = PREFIX + 'REQUEST';
export const SUCCESS = PREFIX + 'SUCCESS';
export const FAILURE = PREFIX + 'FAILURE';

function checkIfAllItemAreLoaded(state) {
  if(!state)
    return false;

  const {claddings, energy, environments, materials, mediums, products, translations, adapters, settings, materialstandards, databasedate } = state;

  if(!claddings.loading &&
    !energy.loading &&
    !environments.loading &&
    !materials.loading &&
    !mediums.loading &&
    !products.loading &&
    !translations.loading &&
    !adapters.loading &&
    !settings.loading &&
    !materialstandards.loading &&
    !databasedate.loading
    ) {
    return true;
  }
  return false;
}

export function createMiddleware(config = {}) {
  return store => next => action => {
    const { type, payload } = action;

    switch (type) {
      case FETCH:

        const { url, options, props } = payload;
        next(action);
        // store.dispatch({ type: REQUEST, payload:{ uid, url, props: props ? props : {} } });
        axios.get(url, options)
        .then(function(response) {
          console.log(url + ' - ' + response.statusText);
          store.dispatch({ type: SUCCESS, payload: { response, url, successProps: props ? props : {} } });
        })
        .catch(function(error) {
          console.log(error);
          // store.dispatch({ type: FAILURE, payload: { error, url, props: props ? props : {} } });
        });
        break;

      case SUCCESS:

        next(action);
        const { response, successProps } = payload || {};

        if(successProps && successProps.type === 'application/json' && response && response.data) {
          store.dispatch({
            type: successProps.successAction,
            payload: response.data,
          });
        }
        if(checkIfAllItemAreLoaded(store.getState())) {
          // store.dispatch(initializeProgram())
          store.dispatch(checkIfUserIsLoggedIn());
        }

        break;

      case FAILURE:

        console.log('Failed loading ' + action.payload.url);
        next(action);
        break;

      default:
        next(action);
    }
  };
}
